<template>
  <div
    class="user-notification-data-list-item hover-fade cursor-pointer"
    :class="{
      linkable: !!item.linkUrl,
      unread: isUnread,
    }"
    @click.prevent="() => clickItem()"
  >
    <div class="small">
      <!-- <pre>item: {{ item }}</pre>-->
      <div
        v-if="item.title"
        class="bold text-muted"
      >
        {{ item.title }}
      </div>
      <div
        class=""
        style="white-space: pre-wrap"
      >
        {{ item.body?.trim() || '' }}
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import { ModelCoreUserNotification } from '../models/ModelCoreUserNotifications'

export default {
  name: 'UserNotificationDataListItem',
  props: {
    item: {
      type: Object as PropType<ModelCoreUserNotification>,
      required: true,
    },
  },
  data() {
    return {
      markedAsRead: false, // このコンポーネント内で 既読にしたかどうか
    }
  },
  computed: {
    isUnread() {
      if (this.markedAsRead) {
        return false
      }
      return !this.item.readAt
    },
  },
  // beforeUnmount() {
  //   // if (!this.item.readAt && !this.item.linkUrl) {
  //   //   // linkUrl がないなら、見たあとで既読にする on unmount
  //   //   this.markAsRead()
  //   // }
  // },
  methods: {
    async markAsRead() {
      this.markedAsRead = true
      if (this.item.readAt) {
        return
      }
      try {
        await $core.$userNotificationsService.markAsRead([this.item.id])
      } catch (e) {
        this.markedAsRead = false
        console.error(e)
      }
    },
    clickItem() {
      this.markAsRead()
      if (this.item.linkUrl) {
        $core.$userNotificationsService.goToLink(this.item)
      }
      // show detail
      $core.$appHook.emit('UserNotificationDataList.itemClick', {
        notificationRecord: this.item,
        vueComponent: this,
      })
    },
  },
}
</script>
